import { Injectable } from '@angular/core';
import {
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import moment from 'moment';
import { ScheduleSettingsMode } from '../../enums/screen-settings-mode.enum';

@Injectable({ providedIn: 'root' })
export class CustomValidationService {
  timeValidator(
    startTime: string,
    endTime: string,
    startDate: string,
    endDate: string,
    allDay: string,
    scheduleSettingsMode: string,
    weekDays: string
  ): ValidatorFn {
    return (formGroup: UntypedFormGroup): ValidationErrors => {
      const startControl = formGroup.controls[startTime];
      const endControl = formGroup.controls[endTime];
      const startDateControl = formGroup.controls[startDate];
      const endDateControl = formGroup.controls[endDate];
      const allDayControl = formGroup.controls[allDay];
      const weekDaysControl = formGroup.controls[weekDays];
      const scheduleModeValue: ScheduleSettingsMode = formGroup.controls[scheduleSettingsMode].value;

      if (allDayControl.value) {
        this.clearControls([startControl, endControl]);
      }

      this.checkEmptyControls(startControl, endControl);
      const isSameDay: boolean =
        scheduleModeValue === ScheduleSettingsMode.Range
          ? moment(startDateControl.value).isSame(endDateControl.value, 'day')
          : !allDayControl.value;

      if (isSameDay && +moment(startControl.value, 'HH:mm:ss').toDate() > +moment(endControl.value, 'HH:mm:ss').toDate()) {
        this.setErrors([startControl, endControl], { incorrectOrder: true });
        return { incorrectOrder: true };
      } else {
        this.clearControls([startControl, endControl]);
      }

      if (isSameDay && startControl.value && endControl.value &&
        +moment(endControl.value, 'HH:mm:ss').toDate() - +moment(startControl.value, 'HH:mm:ss').toDate() < 60000) {
        this.setErrors([startControl, endControl], { lessThanMinute: true });
        return { lessThanMinute: true };
      } else {
        this.clearControls([startControl, endControl]);
      }

      if (!isSameDay && +new Date(startDateControl.value) > +new Date(endDateControl.value)) {
        this.setErrors([startDateControl, endDateControl], { EndBiggerThanStart: true });
      } else {
        this.clearControls([startDateControl, endDateControl]);
      }

      const weekDaysFormGroup = weekDaysControl as UntypedFormGroup;
      if (scheduleModeValue === ScheduleSettingsMode.Weekly && allDayControl.value === false && weekDaysFormGroup) {
        const isInvalid = !Object.values(weekDaysFormGroup.controls).some(control => control.value);

        if (isInvalid) {
          this.setErrors([weekDaysControl], { weekDaysError: true });
        }
      } else if (allDayControl.value) {
        this.clearControls([weekDaysControl]);
      }

      return null;
    };
  }

  private clearControls(controls: AbstractControl[]): void {
    controls.forEach((control) => control.setErrors(null));
  }

  private setErrors(
    controls: AbstractControl[],
    error: ValidationErrors
  ): void {
    controls.forEach((control) => {
      control.markAsTouched();
      control.setErrors(error);
    });
  }

  private checkEmptyControls(
    startControl: AbstractControl,
    endControl: AbstractControl
  ): void {
    if (
      !startControl ||
      !startControl.value ||
      !endControl ||
      !endControl.value
    ) {
      startControl.setErrors({ required: true });
      endControl.setErrors({ required: true });
    }
  }
}
